export default {
  default: [
    {
      path: "/spaar-contract/aanmaken",
      name: "fundingContracts.create",
      component: () => import("./views/FundingContractFormView.vue")
    },
    {
      path: "/spaar-contract/:contractId/verklaring-herkomst-middelen",
      name: "fundingContracts.declarationOfSourceOfFunds.edit",
      component: () => import("./views/DeclarationOfSourceOfFundsFormView.vue")
    },
    {
      path: "/spaar-contract/aangevraagd",
      name: "fundingContracts.requested",
      component: () => import("./views/ContractRequestedView.vue")
    }
  ]
};
